import cn from 'classnames/bind';
import React, { FC, PropsWithChildren } from 'react';
import ReactModal from 'react-modal';

import { CloseButton } from '@/shared/components/CloseButton/CloseButton';

import styles from './Modal.module.css';

const cx = cn.bind(styles);

type ElementColorScheme = 'dark' | 'light';

interface ModalProps {
    closeIcon?: boolean;
    closeButtonClassName?: string;
    overlayClassName?: string;
    className?: string;
    rounded?: boolean;
    isHideOnlyByCloseIcon?: boolean;
    colorScheme?: ElementColorScheme;
    contentLabel?: string;
    parentSelector?: () => HTMLElement;
    onHideModal?: VoidFunction;
}

export const Modal: FC<PropsWithChildren<ModalProps>> = (props) => {
    const {
        children,
        closeIcon = true,
        closeButtonClassName,
        overlayClassName,
        rounded = true,
        className,
        isHideOnlyByCloseIcon,
        colorScheme = 'dark',
        contentLabel,
        parentSelector,
        onHideModal,
    } = props;

    const rootClassList = cx('root', `root_${colorScheme}`, className, {
        root_rounded: rounded,
        root_dark: rounded,
    });

    return (
        <ReactModal
            isOpen
            className={rootClassList}
            overlayClassName={cx('overlay', overlayClassName)}
            onRequestClose={!isHideOnlyByCloseIcon ? onHideModal : undefined}
            bodyOpenClassName={cx('body')}
            contentLabel={contentLabel}
            parentSelector={parentSelector}
        >
            {closeIcon && onHideModal && (
                <div className={cx('close-button', closeButtonClassName)}>
                    <CloseButton onHandleClick={onHideModal} colorScheme={colorScheme} />
                </div>
            )}
            <div className={cx('children-wrapper')}>{children}</div>
        </ReactModal>
    );
};
